import React from 'react';
import PageLayout from 'layouts/PageLayout';
import BasicButton from 'components/BasicButton';
import { ROUTE } from 'constants/route';
import { CSSTransition } from 'react-transition-group';

import { ANIMATION_TIMEOUT_APPEAR } from 'constants/animation.js';
import image from 'assets/images/404.svg';
import './styles.css';

const NotFoundPage = props => {
  const goHome = e => {
    if (!props.user.isLoggedIn) {
      e.preventDefault();
      window.location = '/';
    } else {
      props.history.push(ROUTE.HOME);
    }
  };

  return (
    <PageLayout
      pageClass="not-found-page"
      pageTitle="Page Not Found"
      mainContent={
        <CSSTransition
          in={true}
          appear={true}
          timeout={ANIMATION_TIMEOUT_APPEAR}
          classNames="fade"
        >
          <div className="not-found-page__row">
            <div className="not-found-page__image">
              <img src={image} alt="empty box" height="auto" width="260px" />
            </div>

            <div className="not-found-page__cta">
              <h1 className="not-found-page__title">
                Sorry, this page isn't available
              </h1>
              <p className="not-found-page__text">
                The link you followed may be broken, or the page may have been
                removed.
              </p>

              <div className="not-found-page__button">
                <BasicButton
                  controlFunc={goHome}
                  btnWidth={180}
                  btnHeight={35}
                  btnFontSize="0.8571rem"
                  btnFontWeight={600}
                  btnText="Go to homepage"
                  btnArrow={false}
                />
              </div>
            </div>
          </div>
        </CSSTransition>
      }
    />
  );
};

export default NotFoundPage;
